import { render, staticRenderFns } from "./SGPTabelaAvancadaComponent.vue?vue&type=template&id=ce0ec7ba"
import script from "./SGPTabelaAvancadaComponent.vue?vue&type=script&lang=js"
export * from "./SGPTabelaAvancadaComponent.vue?vue&type=script&lang=js"
import style0 from "./SGPTabelaAvancadaComponent.vue?vue&type=style&index=0&id=ce0ec7ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports